import MessageContext from "contexts/MessageContext";
import { useContext } from "react";

export const useAntdMessage = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error("useAntdMessage must be used within a MessageProvider");
  }
  return context;
};
